import { Mic, Square } from "lucide-react";
import { useState } from "react";
import type { ProductionReason } from "./models";
import { applyDowntimeVoiceTranscript, type DowntimeVoiceDraft } from "./downtime-voice-entry";
import { useDowntimeVoiceEntry } from "./useDowntimeVoiceEntry";

export function DowntimeVoiceEntry({ draftKey, reasons, draft, onChange, disabled, onBusyChange }: {
  draftKey: string;
  reasons: ProductionReason[];
  draft: DowntimeVoiceDraft;
  onChange: (draft: DowntimeVoiceDraft) => void;
  disabled: boolean;
  onBusyChange?: (busy: boolean) => void;
}) {
  const [transcriptError, setTranscriptError] = useState<string | null>(null);
  const voice = useDowntimeVoiceEntry(draftKey, (text) => {
    const result = applyDowntimeVoiceTranscript(reasons, draft, text);
    setTranscriptError(result.error);
    if (!result.error) onChange(result.draft);
  }, onBusyChange);
  const listening = voice.state === "recording" || voice.state === "recognizing";
  const busy = voice.state !== "idle";
  const start = (local: boolean) => {
    setTranscriptError(null);
    if (local) void voice.startLocal();
    else voice.start();
  };
  return <section className="downtime-voice-entry" aria-label="Sesli duruş nedeni girişi">
    {listening
      ? <button type="button" className="downtime-voice-stop" onClick={voice.stop}>
          <Square size={18} aria-hidden="true" />Durdur
        </button>
      : <button type="button" className="downtime-voice-start" disabled={disabled || busy} onClick={() => start(false)}>
          <Mic size={24} aria-hidden="true" /><span>Sesle neden gir<small>Konuşmanız yazıya çevrilsin</small></span>
        </button>}
    {busy ? <button type="button" onClick={voice.cancel}>İptal</button> : null}
    <small className="downtime-voice-hint">Ses çevrimiçi işlenebilir. Kaydetmeden önce metni kontrol edin.</small>
    {voice.message ? <p role="status">{voice.message}</p> : null}
    {voice.interim ? <p className="downtime-voice-preview" role="status">{voice.interim}</p> : null}
    {transcriptError ? <p role="alert">{transcriptError}</p> : null}
    {!busy && voice.message ? <button type="button" className="downtime-voice-local"
      disabled={disabled} onClick={() => start(true)}>Cihazda yeniden dene</button> : null}
  </section>;
}
